import ButtonSignOut from './ButtonSignOut'

export default ButtonSignOut



// WEBPACK FOOTER //
// ./src/components/ButtonSignOut/index.js